import React, { useState } from "react";
import Navbar from '../navbar/navbar'
import { Layout, Menu, Typography } from 'antd';

import {
    PushpinOutlined,
    TabletOutlined,
    AlertOutlined,
    ControlOutlined,
    EnvironmentOutlined,
    HomeOutlined,
    LinkOutlined,
    UnlockOutlined,
    LogoutOutlined,
    EnterOutlined,
    FieldTimeOutlined,
    FileTextOutlined,
    
} from '@ant-design/icons';

import { Link, useLocation } from "react-router-dom";
import { AuthConsumer } from "../../../main/authenticationProvider";
import styles from './AppLayout.module.scss';
const { Header, Content, Sider, Footer } = Layout;

const AppLayout = ({ isHomePage, ...props }) => {
    const location = useLocation();
    const pathName = location.pathname;
    const [activeKey, setActiveKey] = useState(location.pathname.substring(1));
    const [openKeys, setOpenKeys] = useState(sessionStorage.getItem("subMenuOpen") === "reports" ? "reports" : "");


    const handleOpenAndCloseSubMenu = (e) => {
        const value = sessionStorage.getItem("subMenuOpen");
        if (value === null || value === undefined || value === "") {
            sessionStorage.setItem("subMenuOpen", e.key);
            setOpenKeys(e.key);
        } else {
            sessionStorage.setItem("subMenuOpen", "");
            setOpenKeys("");
        }
    }

    let menuItems = []
    if (props.userType === "arlug_client") {
        menuItems = [
            {
                label: '',
                disabled: true,
                className: 'custom-item'
            },
            {
                label: <Link to="/" children="Home" className={styles['menuText']} />,
                key: 'home',
                icon: <HomeOutlined />,
            },
            {

                label: <Link to="/hourmeter" children="Horímetro" />,
                key: 'hourmeter',
                icon: <FieldTimeOutlined />,
            },
            {
                label: <Link
                    //render={props.isUserAuthenticated}
                    onClick={props.out}
                    to="/login"
                    children="Sair"
                />,
                key: 'logout',
                icon: <LogoutOutlined />,
            },
        ]
    } else {
        menuItems = [
            {
                label: '',
                disabled: true,
                className: 'custom-item'
            },
            {
                label: <Link to="/" children="Home" className={styles['menuText']} />,
                key: 'home',
                icon: <HomeOutlined />,
            },
            {
                label: <Link to="/createroute" children="Rotas" />,
                key: 'createroute',
                icon: <PushpinOutlined />,
            },
            {
                label: <Link to="/statusLink" children={"Vínculos"} />,
                key: 'statusLink',
                icon: <LinkOutlined />,
            },
            {
                label: <Link to="/routeInitiated" children={"Rotas Ativas"} />,
                key: 'routeInitiated',
                icon: <EnterOutlined style={{ transform: 'rotate(180deg)' }} />,
            },
            {
                label: <Link to="/offlineDevice" children="Dispositivos" />,
                key: 'offlineDevice',
                icon: <TabletOutlined />,
            },
            {
                label: 'Relatórios',
                key: 'reports',
                icon: <FileTextOutlined />,
                onTitleClick: (e) => handleOpenAndCloseSubMenu(e),
                children: [
                    {
                        label: <Link to="/positions" children="Posições" />,
                        key: 'positions',
                        icon: <EnvironmentOutlined />,
                    },
                    {
                        label: <Link to="/events" children="Eventos" />,
                        key: 'events',
                        icon: <AlertOutlined />,
                    },
                    {
                        label: <Link to="/commands" children="Comandos" />,
                        key: 'commands',
                        icon: <ControlOutlined />,
                    },
                    {
                        label: <Link to="/accesses" children="Acessos" />,
                        key: 'accesses',
                        icon: <UnlockOutlined />,
                    },
                ]
            },
            {
                label: <Link
                    onClick={props.out}
                    to="/login"
                    children="Sair"
                />,
                key: 'logout',
                icon: <LogoutOutlined />,
            },
        ]
    }



    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Header style={{ backgroundColor: 'rgb(0, 28, 47)', zIndex: 100 }}>
                <Navbar userType={props.userType} landingPage='/' isUserAuthenticated={props.isUserAuthenticated} out={props.out} />
            </Header>
            {props.isUserAuthenticated ? (
                <>
                    <Layout >
                        <Sider
                            breakpoint="lg"
                            collapsedWidth="0"
                            style={{
                                overflow: 'auto',
                                height: '100vh',
                                position: 'fixed',
                                top: 0,
                            }}
                        >
                            <Menu
                                selectedKeys={activeKey}
                                openKeys={openKeys}
                                onOpenChange={e => setOpenKeys([...e])}
                                theme="dark"
                                mode="inline"
                                inlineIndent={15}
                                style={{ borderRight: 0, width: '100%', }}
                                items={menuItems}
                            >

                            </Menu>
                        </Sider>
                        <Layout
                            style={{
                                marginLeft: 200,
                            }}
                        >
                            <Content style={{ padding: pathName === "/" ? '0px' : '12px' }}>
                                {props.children}
                            </Content>
                        </Layout>
                    </Layout>
                    <Footer

                        style={{
                            textAlign: 'center',
                            height: '20px',
                        }}
                    >
                        <Typography style={{ fontWeight: 500, marginLeft: '200px' }}>Rota Track Copyright ©{new Date().getFullYear()}</Typography>
                    </Footer>
                </>

            ) : (
                <Content className={props.className}>
                    {props.children}
                </Content>
            )}



        </Layout>
    );
}

export default (props) => {
    return <AuthConsumer>
        {(context) => {
            return <AppLayout userType={context.userType} className={props.className} isUserAuthenticated={true} out={context.endSession} children={props.children} />
        }}
    </AuthConsumer>
}